module.exports = __webpack_public_path__ + "media/whale sharks/small_whale_swim-772bdf62.jpg";